import React from "react";

const Banner = () => {
  return (
    <>
      <div className="sticky top-0 bg-purple-800 p-2 text-slate-200 w-full ">
        <p className="text-center animate-pulse">
          Exciting changes are coming to our website! Please pardon the
          appearance while I work behind the scenes.
        </p>
      </div>
    </>
  );
};

export default Banner;
